import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_whatsapp-background.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_trash.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-bf80fcc4")

_pushScopeId("data-v-bf80fcc4")
const _hoisted_1 = { class: "bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden" }
const _hoisted_2 = { class: "flex items-center justify-between p-6 border-b border-gray-200" }
const _hoisted_3 = { class: "text-xl font-semibold text-gray-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_5 = { class: "flex flex-col p-4" }
const _hoisted_6 = {
  class: "flex-1 overflow-y-auto h-40 pt-2 custom-scrollbar",
  style: {"max-height":"300px"}
}
const _hoisted_7 = { class: "space-y-2 bg-gray-lp-1000 rounded-t-xl" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "font-semibold text-sm text-gray-lp-300 mb-1" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = { class: "text-gray-lp-300 text-sm" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-6 h-6"
}, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center gap-4" }
const _hoisted_14 = { class: "text-right text-gray-lp-300 text-sm flex flex-row gap-2" }
const _hoisted_15 = { class: " font-bold" }
const _hoisted_16 = { class: "font-medium" }
const _hoisted_17 = {
  class: "font-bold",
  "data-testid": "pickup-dashboard-modal-transfer-weight"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: " w-6 h-6"
}, null, -1)
const _hoisted_19 = { class: "flex-shrink-0 pb-6 bg-white border-t border-gray-100" }
const _hoisted_20 = {
  key: 0,
  class: "p-4 bg-gray-lp-1600 rounded-b-xl"
}
const _hoisted_21 = { class: "flex flex-row justify-between gap-4" }
const _hoisted_22 = { class: "font-bold text-gray-lp-300" }
const _hoisted_23 = { class: "text-right text-gray-lp-300 flex flex-row gap-4" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "font-normal" }
const _hoisted_26 = {
  class: "font-bold",
  "data-testid": "pickup-dashboard-modal-transfer-total-weight"
}
const _hoisted_27 = { class: "mb-2 mt-6 " }
const _hoisted_28 = { class: "block text-sm text-gray-lp-300 font-semibold mb-2" }
const _hoisted_29 = { class: "flex items-center justify-end gap-3 p-6 border-t border-gray-200" }
const _hoisted_30 = { class: "justify-center" }
const _hoisted_31 = { class: "text-xs font-medium text-gray-lp-300" }
const _hoisted_32 = { class: "max-h-100 overflow-y-auto custom-scrollbar" }
const _hoisted_33 = { class: "w-full mt-3" }
const _hoisted_34 = { class: "sticky top-0 bg-white z-10 text-sm text-gray-lp-300 font-semibold border-t border-b border-gray-lp-1400" }
const _hoisted_35 = { class: "py-2.5 w-12" }
const _hoisted_36 = { class: "px-3 flex justify-start" }
const _hoisted_37 = { class: "py-2.5 w-44" }
const _hoisted_38 = { class: "px-3 flex justify-start" }
const _hoisted_39 = { class: "py-2.5 w-44" }
const _hoisted_40 = { class: "px-3 flex justify-start" }
const _hoisted_41 = { class: "py-2.5 w-44" }
const _hoisted_42 = { class: "px-3 flex justify-start text-left" }
const _hoisted_43 = { class: "justify-end px-3 py-3 font-normal" }
const _hoisted_44 = { class: "text-left" }
const _hoisted_45 = { class: "text-left px-3 py-3" }
const _hoisted_46 = { class: "flex flex-col items-start gap-1" }
const _hoisted_47 = { class: "font-medium" }
const _hoisted_48 = { class: "flex flex-row gap-1" }
const _hoisted_49 = { class: "font-normal text-gray-lp-600" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-4 h-4"
}, null, -1)
const _hoisted_51 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_52 = {
  class: "text-left px-3 py-3 font-normal",
  "data-testid": "pickup-dashboard-modal-transfer-quantity"
}
const _hoisted_53 = { class: "justify-center" }
const _hoisted_54 = { class: "text-xs font-medium text-gray-lp-300" }
const _hoisted_55 = { class: "max-h-100 overflow-y-auto custom-scrollbar" }
const _hoisted_56 = { class: "w-full mt-3" }
const _hoisted_57 = { class: "sticky top-0 bg-white z-10 text-sm text-gray-lp-300 font-semibold border-t border-b border-gray-lp-1400" }
const _hoisted_58 = { class: "py-2.5 w-12" }
const _hoisted_59 = { class: "px-3 flex justify-start" }
const _hoisted_60 = { class: "py-2.5 w-44" }
const _hoisted_61 = { class: "px-3 flex justify-start" }
const _hoisted_62 = { class: "py-2.5 w-44" }
const _hoisted_63 = { class: "px-3 flex justify-start" }
const _hoisted_64 = { class: "py-2.5 w-44" }
const _hoisted_65 = { class: "px-3 flex justify-start text-left" }
const _hoisted_66 = { class: "justify-end px-3 py-3 font-normal" }
const _hoisted_67 = { class: "text-left" }
const _hoisted_68 = { class: "text-left px-3 py-3" }
const _hoisted_69 = { class: "flex flex-col items-start gap-1" }
const _hoisted_70 = { class: "font-medium" }
const _hoisted_71 = { class: "flex flex-row gap-1" }
const _hoisted_72 = { class: "font-normal text-gray-lp-600" }
const _hoisted_73 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-4 h-4"
}, null, -1)
const _hoisted_74 = { class: "text-left px-3 py-3 font-normal" }
const _hoisted_75 = {
  class: "text-left px-3 py-3 font-normal",
  "data-testid": "pickup-dashboard-modal-transfer-quantity"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.isSingleSeller ? "Transfer Pick Up" : "Transfer Multiple Pick Up"), 1),
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
              }, [
                _hoisted_4
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedSellers, (seller) => {
                    return (_openBlock(), _createBlock("div", {
                      key: `${seller.id}-${seller.index}`,
                      class: "flex items-center justify-between px-4 py-2 border-b border-gray-lp-1400"
                    }, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, _toDisplayString(seller.sellerName), 1),
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, _toDisplayString(seller.sellerPhone), 1),
                          _createVNode("a", {
                            href: `https://wa.me/${seller.sellerPhone}`,
                            target: "_blank",
                            class: "flex items-center justify-center"
                          }, [
                            _hoisted_12
                          ], 8, ["href"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("p", _hoisted_15, _toDisplayString(_ctx.fmtQty(seller.packageCount)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.package")), 1),
                          _createVNode("p", _hoisted_16, "(" + _toDisplayString(_ctx.fmtQty(seller.koli)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ") ", 1),
                          _createVNode("p", _hoisted_17, "• " + _toDisplayString(_ctx.fmtWeight(seller.weight)), 1)
                        ]),
                        (!_ctx.isSingleSeller)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.removeSeller(seller.index)),
                              class: "w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full"
                            }, [
                              _hoisted_18
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                (!_ctx.isSingleSeller)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("pickupDashboard.totalSender")) + " (" + _toDisplayString(_ctx.totalSenders) + ") ", 1),
                        _createVNode("div", _hoisted_23, [
                          _createVNode("p", _hoisted_24, _toDisplayString(_ctx.fmtQty(_ctx.totalPackages)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.package")), 1),
                          _createVNode("p", _hoisted_25, " (" + _toDisplayString(_ctx.fmtQty(_ctx.totalKoli)) + " " + _toDisplayString(_ctx.$t("pickupDashboard.koli")) + ")", 1),
                          _createVNode("p", _hoisted_26, " • " + _toDisplayString(_ctx.fmtWeight(_ctx.totalWeight)), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_27, [
                  _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("pickupDashboard.selectCourier")), 1),
                  _createVNode(_component_SelectSearch, {
                    class: "selectCourier",
                    options: _ctx.courierOptions,
                    modelValue: _ctx.selectedCourier,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCourier = $event)),
                    isLoading: _ctx.isLoadingCouriers,
                    placeholder: _ctx.$t('pickupDashboard.selectCourierPlaceholder'),
                    keyName: "name",
                    keyValue: "value",
                    onChange: _ctx.onSelectCourier,
                    onFilter: _ctx.filterAvailableCouriers,
                    onClose: _ctx.onCloseCourierSelect,
                    maxHeight: "120px"
                  }, null, 8, ["options", "modelValue", "isLoading", "placeholder", "onChange", "onFilter", "onClose"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAssign && _ctx.handleAssign(...args))),
                disabled: !_ctx.selectedCourier || !_ctx.selectedCourier.value || _ctx.isAssigning,
                class: "px-6 py-2 bg-red-lp-100 text-white rounded-lg hover:bg-red-lp-100 disabled:bg-gray-300 disabled:cursor-not-allowed",
                style: {"width":"200px"}
              }, _toDisplayString(_ctx.$t("pickupDashboard.assign")), 9, ["disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_BaseModal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('pickupDashboard.transferSuccess'),
      message: _ctx.$t('pickupDashboard.transferSuccessMessage', {
      courierName: _ctx.selectedCourierName,
      packageCount: _ctx.fmtQty(_ctx.totalPackages)
    }),
      image: "ill_badge_success",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8",
      ref: "modal-success-ref",
      customButton: "focus:ring-2 focus:ring-blue"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isShowModalSuccessBooking]
    ]),
    _withDirectives(_createVNode(_component_BaseModal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('pickupDashboard.transferFailed'),
      image: "badge-warning-lg",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8",
      ref: "modal-success-ref",
      customButton: "focus:ring-2 focus:ring-blue"
    }, null, 8, ["onSubmit", "title", "textSuccess"]), [
      [_vShow, _ctx.isShowModalErrorBooking]
    ]),
    _withDirectives(_createVNode(_component_BaseModal, {
      onSubmit: _ctx.onCloseModalAssign,
      title: _ctx.$t('pickupDashboard.partialTransferSuccess'),
      image: "ill_badge_success",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8",
      customWidth: "600px"
    }, {
      custom: _withId(() => [
        _createVNode("div", _hoisted_30, [
          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("pickupDashboard.partialTransferMessage", {
              count: _ctx.errorAssignData.length
            })), 1),
          _createVNode("div", _hoisted_32, [
            _createVNode("table", _hoisted_33, [
              _createVNode("thead", _hoisted_34, [
                _createVNode("th", _hoisted_35, [
                  _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("pickupDashboard.column.no")), 1)
                ]),
                _createVNode("th", _hoisted_37, [
                  _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("pickupDashboard.column.senderName")), 1)
                ]),
                _createVNode("th", _hoisted_39, [
                  _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentType")), 1)
                ]),
                _createVNode("th", _hoisted_41, [
                  _createVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("pickupDashboard.column.totalShipment")), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorAssignData, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: `pickup-shipment-${index}`,
                    class: "border-t border-b border-gray-lp-1400 text-sm text-gray-lp-300"
                  }, [
                    _createVNode("td", _hoisted_43, [
                      _createVNode("div", _hoisted_44, _toDisplayString(index + 1), 1)
                    ]),
                    _createVNode("td", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("span", _hoisted_47, _toDisplayString(item.senderName), 1),
                        _createVNode("div", _hoisted_48, [
                          _createVNode("span", _hoisted_49, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
                          _createVNode("a", {
                            href: `https://wa.me/${_ctx.waNumber(item.senderPhone)}`,
                            target: "_blank",
                            class: "flex items-center justify-center"
                          }, [
                            _hoisted_50
                          ], 8, ["href"])
                        ])
                      ])
                    ]),
                    _createVNode("td", _hoisted_51, _toDisplayString(_ctx.mapShipmentType(item.shipmentType)), 1),
                    _createVNode("td", _hoisted_52, _toDisplayString(_ctx.fmtQty(item.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.totalQuantity)) + ") ", 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "textSuccess"]), [
      [_vShow, _ctx.openPartial]
    ]),
    _withDirectives(_createVNode(_component_BaseModal, {
      onSubmit: _ctx.onCloseModalErrorAllAssign,
      title: _ctx.$t('pickupDashboard.transferAllFailed'),
      image: "badge-warning-lg",
      textSuccess: _ctx.$t('pickupDashboard.manageArea.ok'),
      class: "px-8",
      customWidth: "600px"
    }, {
      custom: _withId(() => [
        _createVNode("div", _hoisted_53, [
          _createVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("pickupDashboard.transferAllFailedMessage", {
              count: _ctx.errorAllAssignData.length
            })), 1),
          _createVNode("div", _hoisted_55, [
            _createVNode("table", _hoisted_56, [
              _createVNode("thead", _hoisted_57, [
                _createVNode("th", _hoisted_58, [
                  _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("pickupDashboard.column.no")), 1)
                ]),
                _createVNode("th", _hoisted_60, [
                  _createVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("pickupDashboard.column.senderName")), 1)
                ]),
                _createVNode("th", _hoisted_62, [
                  _createVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("pickupDashboard.column.shipmentType")), 1)
                ]),
                _createVNode("th", _hoisted_64, [
                  _createVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("pickupDashboard.column.totalShipment")), 1)
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorAllAssignData, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: `pickup-shipment-${index}`,
                    class: "border-t border-b border-gray-lp-1400 text-sm text-gray-lp-300"
                  }, [
                    _createVNode("td", _hoisted_66, [
                      _createVNode("div", _hoisted_67, _toDisplayString(index + 1), 1)
                    ]),
                    _createVNode("td", _hoisted_68, [
                      _createVNode("div", _hoisted_69, [
                        _createVNode("span", _hoisted_70, _toDisplayString(item.senderName), 1),
                        _createVNode("div", _hoisted_71, [
                          _createVNode("span", _hoisted_72, _toDisplayString(_ctx.formatPhoneNumber(item.senderPhone)), 1),
                          _createVNode("a", {
                            href: `https://wa.me/${_ctx.waNumber(item.senderPhone)}`,
                            target: "_blank",
                            class: "flex items-center justify-center"
                          }, [
                            _hoisted_73
                          ], 8, ["href"])
                        ])
                      ])
                    ]),
                    _createVNode("td", _hoisted_74, _toDisplayString(_ctx.mapShipmentType(item.shipmentType)), 1),
                    _createVNode("td", _hoisted_75, _toDisplayString(_ctx.fmtQty(item.totalShipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.totalQuantity)) + ") ", 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "title", "textSuccess"]), [
      [_vShow, _ctx.openModalAllError]
    ])
  ], 64))
})